module.exports = __webpack_public_path__ + "static/media/light_rain_audio.5dfa382b.mp4";